import { useEffect } from "react";
import { useAuth } from "./AuthContext";
import LoadingScreen from "../components/LoadingScreen";

// /logout route — delegates to the single logout() in AuthContext, which clears
// the shared session cookie (app + apex), wipes this origin's localStorage, and
// hard-redirects to the apex home. No local navigate needed (logout() redirects).
const Logout = () => {
  const { logout } = useAuth();
  useEffect(() => { logout(); }, [logout]);
  return <LoadingScreen />;
};

export default Logout;
